"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionSelection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
const Subtitle_1 = require("../../atoms/Subtitle/Subtitle");
const Title_1 = require("../../atoms/Title/Title");
const CountryDropdown_1 = require("../../molecules/CountryDropdown/CountryDropdown");
const mediaQueries_1 = require("../../styles/mediaQueries");
function RegionSelection({ country, setCountry, onCountrySelect, isActiveContinue, setIsActiveContinue, onContinue, showWarning, }) {
    const { t } = (0, i18n_1.useTranslation)();
    const showErrorMessage = !country && showWarning;
    return ((0, jsx_runtime_1.jsxs)(RightContainer, { "data-e2e": 'RegionSelection_RightContainer', children: [(0, jsx_runtime_1.jsxs)(StyledTitle, { "data-e2e": 'RegionSelection_StyledTitle', children: [(0, jsx_runtime_1.jsx)(Heading, { "data-e2e": 'RegionSelection_Heading', children: t(i18n_1.Strings.userOnboarding.selectServer.welcome) }), (0, jsx_runtime_1.jsx)(Heading, { "data-e2e": 'RegionSelection_Heading', children: t(i18n_1.Strings.userOnboarding.selectServer.heading) })] }), (0, jsx_runtime_1.jsx)(StyledSubtitle, { "data-e2e": 'RegionSelection_StyledSubtitle', children: t(i18n_1.Strings.userOnboarding.selectServer.subtitle) }), (0, jsx_runtime_1.jsxs)(ContentContainer, { "data-e2e": 'RegionSelection_ContentContainer', children: [(0, jsx_runtime_1.jsxs)(DropdownContainer, { "data-e2e": 'RegionSelection_DropdownContainer', children: [(0, jsx_runtime_1.jsx)(StyledCountryDropdown, { onSelect: onCountrySelect, onToggleBtn: setIsActiveContinue, setCountry: setCountry, selectedCountry: country, "data-e2e": 'RegionSelection_StyledCountryDropdown' }), (0, jsx_runtime_1.jsx)(WarningContainer, { "data-e2e": 'RegionSelection_WarningContainer', children: (0, jsx_runtime_1.jsx)(Warning, { "$showError": showErrorMessage, "data-e2e": 'RegionSelection_Warning', children: t(i18n_1.Strings.regionSelector.errorMessage) }) })] }), (0, jsx_runtime_1.jsx)(ButtonContainer, { "data-e2e": 'RegionSelection_ButtonContainer', children: (0, jsx_runtime_1.jsx)(StyledButton, { onClick: onContinue, "$isActive": isActiveContinue, "data-e2e": 'RegionSelection_StyledButton', children: t(i18n_1.Strings.common.continue) }) })] })] }));
}
exports.RegionSelection = RegionSelection;
const RightContainer = styled_components_1.default.div `
  transition: all 300ms linear;
  display: flex;
  flex-basis: auto;
  flex-direction: column;
  align-items: center;

  height: 100%;
  padding: 0px 40px;

  transition: margin-top 300ms;
  justify-content: space-between;
  overflow-y: visible;

  ${mediaQueries_1.device.mobileLandscape `
    margin-top: 32px;
    margin-bottom: 24px;
    justify-content: center;
    flex: 0 0 auto;
    height: calc(100% - 56px);
  `}

  ${mediaQueries_1.device.desktop `
    align-items: flex-start;
    width: 54%;
    max-height: 625px;
    min-width: 400px;
    margin-top: 0;
    margin-bottom: 0;
    justify-content: space-between;
    transition: none;
    padding: 0;
  `}
`;
const StyledTitle = (0, styled_components_1.default)(Title_1.Title) `
  margin-bottom: 16px;

  ${mediaQueries_1.device.desktop `
    height: 164px;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    
    text-align: left;
    margin-bottom: 40px;
  `}
`;
const Heading = styled_components_1.default.span `
  font-weight: 300;
  padding: 0 6px;

  ${mediaQueries_1.device.desktop `
    text-align: left;
  `}
`;
const StyledSubtitle = (0, styled_components_1.default)(Subtitle_1.Subtitle) `
  ${mediaQueries_1.device.desktop `
    height: 72px;
    text-align: left;
  `}
`;
const ContentContainer = styled_components_1.default.div `
  justify-content: space-between;
  height: 100%;
  display: flex;
  flex-direction: column;

  ${mediaQueries_1.device.mobile `
    margin-top: 2em;
  `}
`;
const DropdownContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${mediaQueries_1.device.desktop `
    justify-content: left;
  `}
`;
const StyledCountryDropdown = (0, styled_components_1.default)(CountryDropdown_1.CountryDropdown) `
  z-index: 2;
  width: 100%;
  height: 40px;
  margin: 4px 0px;

  color: ${props => props.theme.tools.header.textbox.colors.white};
  background: ${props => props.theme.settings.header};

  pointer-events: initial;

  ${mediaQueries_1.device.mobileLandscape `
    margin-top: 18px;
    transition: transform 300ms;
  `}
  ${mediaQueries_1.device.tablet `
    width: 318px;
  `}
  ${mediaQueries_1.device.desktop `
    width: 320px;
    margin-top: 60px;
    margin-bottom: 0;
  `}
`;
const ButtonContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: auto;
  align-items: end;
`;
const StyledButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  width: 100%;
  height: 48px;
  padding: 0;
  border-radius: 4px;
  margin: 0;

  background-color: ${props => props.$isActive
    ? props.theme.userOnboarding.primaryButton.enabled.background
    : props.theme.userOnboarding.primaryButton.disabled.background};
  color: ${props => props.$isActive
    ? props.theme.userOnboarding.primaryButton.enabled.text
    : props.theme.userOnboarding.primaryButton.disabled.text};

  cursor: ${props => (props.$isActive ? 'pointer' : 'default')};

  transition: background-color 250ms;
  transition: opacity 250ms;

  pointer-events: initial;

  ${mediaQueries_1.device.mobileLandscape `
    transition: margin-top 300ms;
    width: 248px;
  `}

  ${mediaQueries_1.device.desktop `
    width: 248px;
    height: 56px;
  `}
`;
const WarningContainer = styled_components_1.default.div `
  display: flex;
  text-align: left;
  width: 100%;
  padding-left: 5%;

  ${mediaQueries_1.device.mobileLandscape `
    padding-left: 30%;
  `}
  ${mediaQueries_1.device.desktop `
    padding-left: 10%;
  `}
`;
const Warning = (0, styled_components_1.default)('h2') `
  font-size: 12px;
  display: ${props => (props.$showError ? 'block' : 'none')};
  color: ${props => props.theme.designSystem.warning};
`;
